import { Base, Language } from "..";

/** Справочник причин отказа клиента. Без подписок: список перечитывается целиком. */
class ClientRefusalReason extends Base {
	public static async getAll(
		params: ClientRefusalReason.GetAllParams = {},
	): Promise<ClientRefusalReason.Model[]> {
		const res = await this.request(
			(prpc) => prpc.theirsModel.clientRefusalReason.getAll(params),
			{ name: "clientRefusalReason.getAll", silent: false, error: true },
		);

		return Array.isArray(res) ? res : [];
	}

	public static create(params: ClientRefusalReason.New) {
		return this.request(
			(prpc) => prpc.theirsModel.clientRefusalReason.create(params),
			{ name: "clientRefusalReason.create", silent: false, error: true },
		);
	}

	public static update(id: number, params: Partial<ClientRefusalReason.New>) {
		return this.request(
			(prpc) => prpc.theirsModel.clientRefusalReason.update(id, params),
			{ name: "clientRefusalReason.update", silent: false, error: true },
		);
	}

	public static destroy(id: number) {
		return this.request(
			(prpc) => prpc.theirsModel.clientRefusalReason.delete(id),
			{ name: "clientRefusalReason.delete", silent: false, error: true },
		);
	}
}

declare namespace ClientRefusalReason {
	type Name = Partial<Record<Language, string | null>>;

	interface Model {
		id: number;
		name: Name;
		active: boolean;
		taxiServiceIds: number[];
		companyIds: number[];
	}

	interface New {
		name: Name;
		active: boolean;
		taxiServiceIds: number[];
	}

	interface GetAllParams {
		active?: boolean;
		taxiServiceIds?: number[];
	}
}

export default ClientRefusalReason;
